import { defaultEmployerFormValues, EmployerFormValues } from "../common/EmployerFormValues";
import { defaultCriticalIllnessFormValues, CriticalIllnessFormValues } from "./CriticalIllnessFormValues";
import { Taxation } from "../enums/Taxation";

export type CriticalIllnessEmployerFormValues = EmployerFormValues & CriticalIllnessFormValues
    & {
    hoursWorkedPerWeek: string,
    employeeContributionPercentage: string,
    premiumTaxation: Taxation
    criticalIllnessEmployeeContributionPercentage: string,
    criticalIllnessPremiumTaxation: Taxation
}

export const defaultCriticalIllnessEmployerFormValues = {
    ...defaultEmployerFormValues,
    ...defaultCriticalIllnessFormValues,
    hoursWorkedPerWeek: '',
    employeeContributionPercentage: '',
    premiumTaxation: '',
    criticalIllnessEmployeeContributionPercentage: '',
    criticalIllnessPremiumTaxation: ''
}